export default "__VITE_ASSET__CZIBh58d__"